module.exports = __webpack_public_path__ + "static/use-case-8-content-4-04659687f0e7be7a44d22620933a1e82.png";